/* eslint-disable no-shadow */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import MatchMedia from '../../components/ui/MatchMedia/MatchMedia';
import constants from '../../config/constants';
import { track } from '../../external_dependencies/analytic/index';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { withCart } from '../../utils/CartContext';
import { withDigitalData } from '../../utils/DigitalDataContext';
import _ from '../../utils/LodashImports';
import { withProduct } from '../../utils/ProductContext';
import { withUser } from '../../utils/UserContext';
import { getErrorMessage } from '../../utils/errorHandler';
import * as productUtils from '../../utils/product/productUtils';
import {
  getCheapestVariantId,
  getFirstMatchingVariantId,
  getSelectedColorSwatchIndex,
  getUniqueColorVariants,
  getUniqueOperators,
  getUniqueSizes,
  getVariant,
} from '../../utils/variant';
import BuyTogether from './BuyTogether/BuyTogether';
import HardlineProductSpecifications from './Hardline/HardlineProductSpecifications';
import ModernProductSpecifications from './Modern';
import SoftlineProductSpecifications from './Softline/SoftlineProductSpecifications';
import { requestProductFromStore, requestSkuStocksFromStore } from './helpers';
import useInput from './useInput';

const ProductSpecifications = ({
  layoutType,
  product,
  appCtx,
  cart,
  isVendorLogin,
  currentTab,
  vendorData,
  digitalData,
}) => {
  const {
    variants,
    currentVariant: currentVariantId,
    attributes,
    changeVariant,
    isOutOfStock,
    maxOnCartAmount,
    colorMetrics,
  } = product;

  const { sendIsColorPurshased, setColorSwatch } = colorMetrics;

  const {
    isSizeSelected,
    setSizeSelection,
    setShowCart,
    setVariantSelectionVisible,
    setQuantityWhileVariantSelectionVisible,
    selectedSize,
    setSelectedSize,
    selectedOperatorId,
    setSelectedOperatorId,
    warrantyOptionCurrent,
    setWarrantyOptionCurrent,
  } = cart;

  const currentVariant = getVariant(variants, currentVariantId);
  const { id: productId } = product;
  const { id: skuId } = currentVariant;
  const { tenant, regionCode, store } = appCtx;
  const offeringId = _.get(currentVariant, 'offerings[0]offeringId', '');
  const { inputVal } = useInput(maxOnCartAmount);
  const isPumAvailable = product.attributes && product.attributes.isPumAvailable;
  const pumQuantity = isPumAvailable ? product.attributes.pumQuantity : 1;
  const { variantSwatchType } = product;

  const primeShipping = product.attributes && product.attributes.isPrimeAvailable;

  const isConnectProduct = productUtils.isConnectProduct(product);

  const colorVariants = getUniqueColorVariants(currentVariant, product.variants);

  digitalData.pdp.setProductColorsQty(colorVariants.length);

  const [selectedColorSwatchIndex, setColorIndex] = useState(-1);
  const [errorAddingToCart, setErrorAddingToCart] = useState('');
  const [prevLength, setPrevLength] = useState(0);
  const { sizeChartData = {}, fomo = {} } = currentVariant;
  const sizeChartTable = product?.sizeChartTable || null;
  const brandLogoUrl = product?.brandLogoUrl || null;
  const expressDeliveryLimit = _.get(currentVariant, 'expressDeliveryLimit', 9999);

  useEffect(() => {
    if (colorVariants.length !== prevLength) {
      const indices = Array.from({ length: colorVariants.length }, (_, i) => colorVariants[i].label);
      setColorSwatch(indices);
      setPrevLength(colorVariants.length);
    }
  }, [colorVariants, prevLength, setColorSwatch]);

  const currentColorName = colorVariants[selectedColorSwatchIndex]
    ? colorVariants[selectedColorSwatchIndex].label
    : undefined;

  const sizes = getUniqueSizes(currentColorName, product.variants);

  // const [selectedSize, setSize] = useState(null);
  const [serviceOption, setServiceOption] = useState(null);

  const selectCheapestVariant = (colorName) => {
    const updatedOperators = getUniqueOperators(colorName, product.variants);
    const variantId = getCheapestVariantId(variants, updatedOperators, regionCode);
    if (!variantId) {
      return;
    }
    setSelectedOperatorId(variantId);
    setSizeSelection(true);
    setVariantSelectionVisible(false);
    changeVariant(tenant, variantId, store, regionCode);
  };

  const colorSwatchHandler = ({ label: colorName }) => {
    const variantId = getFirstMatchingVariantId(variants, {
      colorName,
      size: selectedSize,
    });
    changeVariant(tenant, variantId, store, regionCode);
    if (isConnectProduct) {
      selectCheapestVariant(colorName);
    }
  };

  const sizeChangeHandler = (size) => {
    const variantId = getFirstMatchingVariantId(variants, {
      colorName: currentColorName,
      size,
    });
    const newVariant = getVariant(variants, variantId);
    const currentSize = _.get(newVariant, 'attributes.size', '');

    const newSize = size.toUpperCase() === currentSize.toUpperCase() ? size : undefined;

    setSelectedSize(newSize);
    setSizeSelection(true);
    setVariantSelectionVisible(false);
    changeVariant(tenant, variantId, store, regionCode);
  };

  const operators = getUniqueOperators(currentColorName, product.variants);

  const operatorChangeHandler = (connectOperator) => {
    if (!connectOperator) {
      setSizeSelection(false);
      setVariantSelectionVisible(true);
      setSelectedOperatorId('');
      return;
    }
    const variantId = getFirstMatchingVariantId(variants, {
      colorName: currentColorName,
      size: selectedSize,
      connectOperator,
    });
    setSelectedOperatorId(variantId);
    setSizeSelection(true);
    setVariantSelectionVisible(false);
    changeVariant(tenant, variantId, store, regionCode);
  };

  useEffect(() => {
    if (!selectedOperatorId && isConnectProduct) {
      selectCheapestVariant(currentColorName);
    }

    // [FAFB-886] : When variants has operators but viewTemplate !== 'CONNECT'
    if (!isConnectProduct && operators.length !== 0) {
      setSelectedOperatorId(operators[0].id);
      setSizeSelection(true);
      setVariantSelectionVisible(false);
    }
  }, [operators]);

  const [storeSkuData, setStoreSkuData] = useState({});
  const vendorDataExists = Object.entries(vendorData).length > 0;

  const fetchDataForAgent = async () => {
    const response = await requestSkuStocksFromStore(currentVariant, vendorData, regionCode);
    if (response && response.success && response.state.SRXProduct) {
      setStoreSkuData(response.state.SRXProduct);
    }
    return null;
  };

  const isSizeAvailable = (sizeList) => {
    const selected = sizeList.find((size) => size.value === selectedSize);
    return selected && selected.available;
  };

  const validateSelectedSize = () => {
    if (!selectedSize) {
      return;
    }
    if (!isSizeAvailable(sizes)) {
      setSelectedSize(null);
      setVariantSelectionVisible(true);
      setSizeSelection(false);
    }
  };

  const m2AttributeValue = productUtils.getM2ArrtibuteValue(attributes);

  const [m2Quantity, setM2Quantity] = useState(1);
  const [m2ResultValue, setM2ResultValue] = useState(0);
  const [m2Value, setM2Value] = useState('');
  const [isExtraM2Checked, setIsExtraM2Checked] = useState(true);

  const handleM2ValueChange = (evt) => {
    const re = /(^[0-9\b]+$|^\d*,{1}(\d)?$)/;
    if (evt.target.value === '' || re.test(evt.target.value)) {
      setM2Value(evt.target.value);
    }
  };

  const handleExtraM2Change = (isSelected) => {
    setIsExtraM2Checked(isSelected);
  };

  const handleM2ResultChange = (value) => {
    if (!Number.isNaN(value)) {
      setM2ResultValue(value);
      return;
    }
    setM2ResultValue(0);
  };
  const handleM2QuantityChange = (quantity) => {
    if (quantity && !Number.isNaN(quantity)) {
      setM2Quantity(quantity);
      product.updateSelectedProductQuantity(quantity);
      return;
    }
    setM2Quantity(1);
  };

  useEffect(() => {
    validateSelectedSize();
  }, [sizes]);

  useEffect(() => {
    if (sizes.length === 1 && sizes[0].available) {
      setSelectedSize(sizes[0].value);
      setSizeSelection(true);
    } else {
      setSelectedSize(null);
      setSizeSelection(false);
    }
  }, [selectedColorSwatchIndex]);

  useEffect(() => {
    if (!isOutOfStock) {
      setColorIndex(getSelectedColorSwatchIndex(colorVariants, currentVariant));
    }
  }, [currentVariant, product]);
  const handleUnload = () => {
    const eventToDigitalData = new CustomEvent('DDPDPSetFinalAddToCartMetric', {
      bubbles: true,
    });
    window.dispatchEvent(eventToDigitalData);
  };
  useEffect(() => {
    if (isVendorLogin && vendorDataExists) fetchDataForAgent();
    window.addEventListener('beforeunload', handleUnload);
    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, []);
  const [isAddToCartInProgress, setIsAddToCartInProgress] = useState(false);
  const [isDeliveryTypeTooltipEnabled, setIsDeliveryTypeTooltipEnabled] = useState(false);
  const [deliveryTypeTooltip, setDeliveryTypeTooltip] = useState('');
  const [isRemoveFromCartInProgress, setIsRemoveFromCartInProgress] = useState(false);

  const timeputForLoginModalOn401 = _.get(appCtx, 'siteConfig.textDictionary.TIMEOUT_FOR_LOGIN_MODAL', 1000);
  const isCartPersistanceEnabled = _.get(appCtx, 'siteConfig.toggles.isCartPersistanceEnabled', false);
  const isFloorCalculatorEnabled = _.get(appCtx, 'siteConfig.toggles.isFloorcalculatorEnabled', true);

  const handleAddToCart = (
    quantity,
    totalQuantity = 1,
    cartLineId = '',
    customInfo = {},
    customCartLineNumber = ''
  ) => {
    sendIsColorPurshased(currentColorName);
    if (isAddToCartInProgress || isRemoveFromCartInProgress) {
      return;
    }
    const sellerId = _.get(product, 'variants[0].offerings[0].sellerId', '');
    let products = {
      skuId,
      productId,
      quantity: m2AttributeValue > 0 && isFloorCalculatorEnabled ? m2Quantity : quantity,
      offeringId,
      isInternational: _.get(product, 'internationalShipping.applicable', false),
      cartLineId,
      totalQuantity,
    };

    if (warrantyOptionCurrent) {
      products = {
        ...products,
        warrantySkuId: warrantyOptionCurrent.value,
        warrantyOfferingId: warrantyOptionCurrent.offeringId || '',
      };
    }
    if (serviceOption && serviceOption.length) {
      products = {
        ...products,
        serviceOptions: serviceOption,
      };
    }

    setIsAddToCartInProgress(true);
    setErrorAddingToCart('');
    const changeDeliveryFlow = totalQuantity === expressDeliveryLimit;
    const productWithServices =
      serviceOption && serviceOption.length ? { ...product, serviceOptions: serviceOption } : product;

    cart
      .addProduct({
        appCtx,
        replaceCartItems: true,
        products: [products],
        showLightBox: !isCartPersistanceEnabled,
        isBuyNowApplicable: cart.isBuyNowApplicable(_.get(appCtx, 'siteConfig.toggles'), sellerId),
        product: productWithServices,
        changeDeliveryFlow,
        customInfo,
        customCartLineNumber,
      })
      .then((res) => {
        if (res && res.length) {
          const errorMessage = getErrorMessage(res, appCtx.siteConfig);
          const errorCode = _.get(res, '[0].code', '');
          setErrorAddingToCart(errorMessage);
          if (errorCode === constants.ATC_SESSION_EXPIRED_CODE) {
            setIsAddToCartInProgress(false);
            setTimeout(() => {
              cart.setShowLoginForm(true);
            }, timeputForLoginModalOn401);
          }
        } else {
          track('addToCart');
          const eventToDigitalData = new CustomEvent('DDPDPATCQuantitySelector', {
            detail: {
              maxCartQuantity: maxOnCartAmount,
              value: inputVal,
            },
            bubbles: true,
          });
          window.dispatchEvent(eventToDigitalData);
        }
        setIsAddToCartInProgress(false);
        if (changeDeliveryFlow) {
          setDeliveryTypeTooltip(constants.AVAILABILITY_HOMEDELIVERY);
          setIsDeliveryTypeTooltipEnabled(true);
          track('tooltipChangeDeliveryType', { deliveryType: constants.AVAILABILITY_HOMEDELIVERY, skuId });
        }
      });
  };

  const handleRemoveFromCart = ({ quantity = 1, cartLineId = '', totalQuantity }) => {
    if (isAddToCartInProgress || isRemoveFromCartInProgress) {
      return;
    }

    const products = {
      cartLineId,
      quantity,
      offeringId,
      totalQuantity,
    };

    setIsRemoveFromCartInProgress(true);
    setErrorAddingToCart('');

    const changeToExpress = totalQuantity - 1 === expressDeliveryLimit;

    cart
      .removeProduct({
        appCtx,
        products: [products],
        changeDeliveryFlow: changeToExpress,
      })
      .then((res) => {
        if (res && res.length) {
          const errorMessage = getErrorMessage(res, appCtx.siteConfig);
          const errorCode = _.get(res, '[0].code', '');
          setErrorAddingToCart(errorMessage);
          if (errorCode === constants.ATC_SESSION_EXPIRED_CODE) {
            setIsRemoveFromCartInProgress(false);
            setTimeout(() => {
              cart.setShowLoginForm(true);
            }, timeputForLoginModalOn401);
          }
        } else {
          const eventToDigitalData = new CustomEvent('DDPDPRemoveQuantitySelector', {
            detail: {
              value: inputVal - 1,
            },
            bubbles: true,
          });
          window.dispatchEvent(eventToDigitalData);
        }
        setIsRemoveFromCartInProgress(false);
        if (changeToExpress) {
          setDeliveryTypeTooltip(constants.AVAILABILITY_EXPRESS);
          setIsDeliveryTypeTooltipEnabled(true);
          track('tooltipChangeDeliveryType', { deliveryType: constants.AVAILABILITY_EXPRESS, skuId });
        }
      });
  };

  const checkForSelectedVariant = (quantity, totalQuantity, cartLineId, customInfo = {}, customCartLineNumber = '') => {
    const isVariantSelectionApplicable = (sizes && sizes.length > 0) || (operators && operators.length > 0);
    if (isVariantSelectionApplicable && !isSizeSelected) {
      setQuantityWhileVariantSelectionVisible(quantity);
      setShowCart(true);
      setVariantSelectionVisible(true);
    } else {
      setQuantityWhileVariantSelectionVisible(null);
      handleAddToCart(quantity, totalQuantity, cartLineId, customInfo, customCartLineNumber);
      setVariantSelectionVisible(false);
    }
  };

  const onCloseShippingTooltip = () => {
    setIsDeliveryTypeTooltipEnabled(false);
  };

  const productSpecificationsProps = {
    isPumAvailable,
    pumQuantity,
    primeShipping,
    colorVariants,
    selectedColorSwatchIndex,
    colorSwatchHandler,
    selectedSize,
    m2AttributeValue,
    handleM2QuantityChange,
    m2Quantity,
    m2ResultValue,
    handleM2ResultChange,
    m2Value,
    handleM2ValueChange,
    isExtraM2Checked,
    handleExtraM2Change,
    sizes,
    sizeChangeHandler,
    handleAddToCart: checkForSelectedVariant,
    handleRemoveFromCart,
    isRemoveFromCartInProgress,
    isAddToCartInProgress,
    operators,
    operatorChangeHandler,
    addToCartButtonVisible: true,
    showCollectionButtonVisible: false,
    setWarrantyOption: setWarrantyOptionCurrent,
    setServiceOption,
    isVendorLogin,
    storeSkuData,
    currentTab,
    selectedOperatorId,
    errorAddingToCart,
    requestProductFromStore,
    setShowLoginForm: cart.setShowLoginForm,
    showLoginForm: cart.showLoginForm,
    setErrorAddingToCart,
    colorMetrics,
    sizeChartData,
    fomo,
    isDeliveryTypeTooltipEnabled,
    onCloseShippingTooltip,
    deliveryTypeTooltip,
    variantSwatchType,
    sizeChartTable,
    brandLogoUrl,
  };

  const RenderBuyTogether = () => <BuyTogether classes="buy-together-desktop-container" />;
  const isModernLineContainerEnabled = !!appCtx?.siteConfig?.toggles?.isModernLineContainerEnabled;

  const renderLineProductSpecifications = () => {
    if (isModernLineContainerEnabled) {
      return <ModernProductSpecifications {...productSpecificationsProps} />;
    }

    if (layoutType === constants.PRODUCT_CONSTANTS.HARDLINE) {
      return <HardlineProductSpecifications {...productSpecificationsProps} />;
    }

    return <SoftlineProductSpecifications {...productSpecificationsProps} />;
  };

  return (
    <>
      {renderLineProductSpecifications()}

      <MatchMedia
        content={{
          mobile: () => null,
          tablet: RenderBuyTogether,
          desktop: RenderBuyTogether,
        }}
      />
    </>
  );
};

ProductSpecifications.defaultProps = {
  layoutType: constants.PRODUCT_CONSTANTS.HARDLINE,
  currentTab: '',
  vendorData: {},
};

ProductSpecifications.propTypes = {
  layoutType: PropTypes.string,
  currentTab: PropTypes.string,
  vendorData: PropTypes.object,
  product: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
  isVendorLogin: PropTypes.bool.isRequired,
  digitalData: PropTypes.object.isRequired,
};

export { ProductSpecifications };
export default withUser(withCart(withProduct(withApplicationContext(withDigitalData(ProductSpecifications)))));
